"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessError = void 0;
const util_1 = require("util");
class BusinessError extends Error {
    constructor(error, ...params) {
        super(JSON.stringify(Object.assign(Object.assign({}, error), { errorMsg: (0, util_1.format)(error.errorMsg, ...params) })));
        this.errorCode = error.errorCode;
        this.errorMsg = (0, util_1.format)(error.errorMsg, ...params);
    }
}
exports.BusinessError = BusinessError;
